import React, { useState, useEffect , useRef } from "react";
import AppRoutes from "../App.routes";
import "./Home.scss";
import { getUserInfo, logout } from "../services/ExperienceBankAPI";
import { Layout, Row, Col,Divider, Modal, Button, Spin, Tooltip, notification } from "antd";
import { useNavigate } from "react-router-dom";
import { RDMenu } from "@zs-ca/react-cd";
import { setting, SideNavBarData, ProductLogo } from "./SideNavBarData";
import DataUpdates from "./data-updates/DataUpdates";
import HelpCenter from "../shared/help-center/HelpCenter";
import { setUserDetail, setNavigationTab, setExceedingCardsInReport } from "../reducer/PEBCommonSlice";
import Notification from "../shared/Notification/Notification.jsx";
import { useSelector, useDispatch } from "react-redux";
import { NotificationTypes } from "../shared/Notification/Notification.jsx";
import { setNotificationData } from "../reducer/PEBCommonSlice.js";
import { useLocation } from "react-router-dom";
import MaintenancePage from "../shared/MaintenancePage/MaintenancePage.jsx";
import ConcurrentSession from "./concurrent-session/ConcurrentSessionModal.jsx";
import LillyIcon from "../assets/icons/lilly-updated-icon.svg";
import GileadIcon from "../assets/icons/Gilead-logo.svg";
import SanofiIcon from "../assets/icons/sanofi-logo.svg";
import ZSLogo from "../assets/icons/zs-logo-colored.svg";
import PEBGlobeIcon from "../assets/icons/globe-icon.svg";
import JJIcon from "../assets/icons/johnson-johnson-logo.svg";
import AZIcon from "../assets/icons/az-logo.png";
import { MAX_ALLOWED_CARDS } from "../constants/ResponseDetailConstant.js";
import { LoadingOutlined  } from "@ant-design/icons";
import GetMoreInsightsModal from "./get-more-insights/getMoreInsightsModal.jsx";
import NovartisIcon from "../assets/icons/novartis.svg";
import BingIcon from "../assets/icons/prod-bing-logo.svg";
import UserDetailsModal from "./landing-page/UserDetailsModal.jsx";

const { Header, Content, Sider } = Layout;

function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const idmUrl = process.env.REACT_APP_IDM_URL;
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const bespokeInsightsRedirectURL = process.env.REACT_APP_ENV_SWITCH_URL;
  const dispatch = useDispatch();
  const [userAuthenticated, setUserAuthenticated] = useState(false);
  const [userIdCheck, setUserIdCheck] = useState(true);
  const [userDetails, setUserDetails] = useState();
  const tabValue = useSelector((state) => state.PEBCommon?.navigationTab);
  const userInfo = useSelector((state) => state.PEBCommon?.userDetail);  
  const [isModalVisible,setisModalVisible] = useState(false);
  const [isUserDetailsModalVisible, setIsUserDetailsModalVisible] = useState(false);
  const tabName = useSelector((state) => state.PEBCommon?.tabName); 
  
  const analysisLockFlagStatus = useSelector(
    (state) => state.PEBCommon?.analysisLockFlag
  );
   const totalNumberOfCards = useSelector(
      (state) => state.PEBCommon?.findingsReport?.supporting_data
    );
    const loadingDisplayCategoryQuesData = useSelector(
      (state) => state.PEBCommon?.loadingDisplayCategoryQuesData
    );
    
     const exceedingCardsInReport = useSelector(
        (state) => state.PEBCommon?.exceedingCardsInReport
      );
       const exceedingCardsInReportRef = useRef(exceedingCardsInReport);
      
        useEffect(()=>{
          // console.log("totalNumberOfCards",totalNumberOfCards);
          
          // setTotalNumberOfCardsState(totalNumberOfCards.length);
          exceedingCardsInReportRef.current = exceedingCardsInReport;

        },[exceedingCardsInReport])
      const antIcon = (
        <LoadingOutlined
          style={{
            fontSize: 60,
            top: '36%',  
            left:'49%',
          }}
          spin
        />
      );
  localStorage.setItem("user_id", userInfo.user_id);
  const [tab, setTab] = useState(tabValue);
  const [sessionFlag, setSessionFlag] = useState(false);
  const environment = userInfo?.environment || "";
  const logoMap = {
    dev: "",
    qa: "",
    demo: "",
    prod_client_1: LillyIcon,
    prod_gild: GileadIcon,
    prod_aszn: AZIcon,
    prod_janj: JJIcon,
    prod_snfi: SanofiIcon,
    prod_nvsp: NovartisIcon,
    prod_bing: BingIcon

  };

  const logoMapStyle = {
    dev: {height : 22 , verticalAlign :"super" , marginBottom :9},
    qa: {height : 24 , verticalAlign :"super"},
    prod_client_1: {height : 32},
    prod_gild: { height :50 , width: 66 ,verticalAlign :"text-bottom" },
    prod_janj:{height : 18 , verticalAlign :"super" , marginBottom :4},
    prod_snfi: {height : 18 , verticalAlign :"super" , marginBottom :7},
    prod_aszn: {height : 22 , verticalAlign :"super" , marginBottom :9},
    prod_nvsp: {height : 22 , verticalAlign :"super" , marginBottom :5},
    prod_bing: {height : 22 , verticalAlign :"super" , marginBottom :3},

  };

  const clientLogo = logoMap[environment] || "";
  const clientLogoStyle = logoMapStyle[environment];

  const redirectToLogin = () => {    
    window.location.replace(`${idmUrl}`);
  };
  function getIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get("id");
  }
  function setCookie(name, value, seconds) {
    const date = new Date();
    date.setTime(date.getTime() + seconds * 1000); // Convert seconds to milliseconds
    const expires = "expires=" + date.toUTCString();
    document.cookie = name + "=" + value + ";" + expires + ";path=/";
  }

  useEffect(() => {
    var navigationType =
      window.performance.getEntriesByType("navigation")[0].type;

    if (navigationType == "back_forward") {
      sessionStorage.removeItem("sessionId");
    }
    const beforeUnloadHandler = async (event) => {
      // const loggedout = sessionStorage.getItem("loggedout");
      // if (loggedout != "yes" ) {
      //   // const message =
      //   //  "Are you sure you want to leave? Your changes may not be saved.";
      //   // window.confirm(message);
      //   // event.returnValue = message;
      // }
    };

    const handleUnload = async () => {
      try {
        // Call your API here to perform logout or any other actions
        const payload = {
          user_id: localStorage.getItem("user_id"),
          logout_from: "tab",
        };

        logout(payload)
          .then((res) => {
            window.close();
          })
          .catch((e) => console.log(e));

        // Close the window or tab
      } catch (error) {
        console.error("Error during logout:", error);
        // Handle error as needed
      }
    };

    // window.addEventListener("beforeunload", handleUnload);
    window.addEventListener("unload", handleUnload);
    return () => {
      // window.removeEventListener("beforeunload", handleUnload);
      window.removeEventListener("unload", handleUnload);
    };
  }, []);

  const userInfoFun = async () => {
    let response = await getUserInfo(); 
    // if(response === undefined){
    //   window.open(`${baseUrl}/exit.html?idmUrl=${idmUrl}`)
    //   return
    // }
    // console.log("response", response);
    const idFlag = response?.data?.maintenance_flag;
    setUserIdCheck(idFlag);
    if (response?.message === "Session Already Active") {
      setSessionFlag(true);
      localStorage.setItem("oldUserInfo" ,localStorage.getItem("userInfo"));
      localStorage.setItem("userInfo", JSON.stringify(response?.data));
      setUserAuthenticated(true);
      // navigate("/session");
      setTimeout(() => {}, 500);
      return true;
    } else if (response?.status === "SUCCEEDED") {
      dispatch(setUserDetail(response?.data));
      sessionStorage.setItem("apiDataFetched",false);
      sessionStorage.setItem("sessionId", response?.data?.session_id);
      sessionStorage.setItem("pilotUserNewSession", true);
      localStorage.setItem("userInfo", JSON.stringify(response?.data));
      setUserDetails(response?.data);
      setUserAuthenticated(true);
      setTimeout(() => {}, 500);
    } else {
      // redirectToLogin();
      setTimeout(() => {}, 500);
    }
  };

  useEffect(() => {
    const id = getIdFromUrl();
    if (id && !sessionStorage.getItem("sessionId")) {
      setCookie("id", id, 10); // 'id' cookie expires in 30 seconds
    }
    if (window == window.top) {
      userInfoFun();
    }
  }, []);

  const [dataUpdatesFlag, setdataUpdatesFlag] = useState(false);
  const dataUpdatesDrawer = (state) => {
    setdataUpdatesFlag(state);
  };

  const onMenuChange = (e) => {
    if (e === "/bespoke-insights") {
      logOutFromPEB();
      //  setTimeout(() => {
      //   window.open(`${bespokeInsightsRedirectURL}`, "_self");
      // }, 1200);
      return;
    }

    if (analysisLockFlagStatus && e === "/explore") {
      dispatch(
        setNotificationData({
          type: NotificationTypes.INFO,
          message:
            "Explore and other functionalities are not active for exports created before 06/09/2024.",
          placement: "topLeft",
        })
      );
    }

    if (
      !analysisLockFlagStatus ||
      e === "/survey-questions" ||
      e === "/analysis-library"
    ) {
      setTab(e);
      navigate(e);
      dispatch(setNavigationTab(e));
    }

  };

  const logOutFromPEB = async () => {
    const payload = {
      user_id: localStorage.getItem("user_id"),
      logout_from: "to_kural",
    };

    notification.info({
      key: "logout-progress",
      description: "Please wait while we redirect",
      icon: <LoadingOutlined spin />,
      duration: 0,
    });

    try {
        await logout(payload);
        window.open(`${bespokeInsightsRedirectURL}`, "_self");
      } 
    catch (error) {
      notification.error({
        key: "logout-progress",
        // message: "Redirection failed",
        description: "Something went wrong. Please try again.",
        placement: "topRight",
        duration: 4,
      });
    }
  };

  const filterNavBarList = () => {
    return SideNavBarData.filter((item) => {
      // Remove "/bespoke-insights" based on the landing_visible is false
      if (!userDetails?.kural_visible && item.key === "/bespoke-insights"|| item.key=="/faq" || item.key=="/getMoreInsights" || item.key === "/userDetails" ) {
        return false;
      }
      return true;
    });
  };
  const getFaqLink = () => {
    return SideNavBarData.filter((item) => {
      if (!userDetails?.kural_visible && item.key === "/bespoke-insights" || item.key!="/faq" ) {
        return false;
      }
      return true;
    });
  };


  const getMoreInsightsLink= () => {
    return SideNavBarData.filter((item) => {
      if (!userDetails?.kural_visible && item.key === "/bespoke-insights" || item.key!=="/getMoreInsights") {
        return false;
      }
      return true;
    });
  };

  const getUserDetailsLink = () => {
    const isZSUser = userInfo?.user_id?.toLowerCase().endsWith("@zs.com");
    if (!isZSUser) return [];
    return SideNavBarData.filter((item) => item.key === "/userDetails");
  };


  const handleSessionContinue = async () => {
    await userInfoFun(); // Re-call the login API
    setSessionFlag(false); // Hide the modal after successful session re-establish
  };


  const onHandleClose = ()=>{
    window.close();
  }
  return (
    <div>
      <Spin 
      // tip="Loading ... " 
      tip={<span className="loading-text">Loading ...</span>} 
      indicator={antIcon} spinning={loadingDisplayCategoryQuesData}
      style={{
        position: 'fixed',   // Keeps it fixed on the screen even when scrolling
        top: '50%',          // Vertically center it
        left: '50%',
        right:'50%',
        transform: 'translate(-50%, -50%)', // Perfect centering
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,                    // Ensure it appears above other content
        pointerEvents: 'none',
        background: 'transparent',     // Ensure no background color is added to the spinner

    }}
      >

      <Notification />
      { (exceedingCardsInReportRef.current>0 || exceedingCardsInReport>0) && (<Modal
                closable={false}
                maskClosable={false}
                open={true}
                footer={[
                  <Button
                    key="submit"
                    type="primary"
                    onClick={() => {
                      exceedingCardsInReportRef.current = 0;
                      dispatch(setExceedingCardsInReport(0))
                    }}
                    style={{ backgroundColor: "#27A6A4" }}>
                    OK
                  </Button>
                ]}>
                <p><strong>{`Currently ${totalNumberOfCards?.length} out of ${MAX_ALLOWED_CARDS} cards have been added to export. Your current selection exceeds the limit by ${exceedingCardsInReport} cards.`}
                </strong></p>
                <p><strong>{`Please remove or unselect ${exceedingCardsInReport} cards to proceed with adding them to the export section.`}</strong></p>
        
              </Modal>)}
      {userAuthenticated && (
        <>
          {!userIdCheck ? (
            <Layout style={{ height: "100vh" }}>
              <Sider
                breakpoint="lg"
                collapsedWidth="0"
                className="side-nav-bar">
                <div className="demo-logo-vertical" />
                <div className="side-nav-bar-container" id="navbar-container">
                  <RDMenu
                    menuItems={ProductLogo}
                    mode="vertical"
                    style={{
                      width: 80,
                      background: "#2F2C3C",
                    }}
                  />

                  {location.pathname !== "/landing" && (
                    <RDMenu
                      menuItems={filterNavBarList()}
                      selectedOption={tabValue}
                      handleMenu={(e) => onMenuChange(e.key)}
                      mode="vertical"
                      style={{
                        width: 80,
                        background: "#2F2C3C",
                        minHeight: "40vh",
                      }}
                    />
                  )}
                  <RDMenu
                    menuItems={setting}
                    handleMenu={(e) => setTab(e.key)}
                    mode="vertical"
                    style={{
                      width: 80,
                      background: "#2F2C3C",
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "flex-end",
                      // YS-FAQ change make this bottom as 90
                      // bottom:90
                      bottom: 45,
                      position: "fixed",
                    }}
                  />

                    {/* YS-FAQ change uncomment this*/}
                    {/* {location.pathname !== "/landing" && (
                    <RDMenu
                      menuItems={getFaqLink()}
                      selectedOption={tabValue}
                      handleMenu={(e) => onMenuChange(e.key)}
                      mode="vertical"
                      style={{
                        width: 80,
                        background: "#2F2C3C",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        bottom: 45,
                        position: "fixed",
                      }}
                    />
                  )} */}
                  {location.pathname === "/landing" && (
                    <RDMenu
                      menuItems={getUserDetailsLink()}
                      selectedOption={tabValue}
                      handleMenu={() => setIsUserDetailsModalVisible(true)}
                      mode="vertical"
                      style={{
                        width: 80,
                        background: "#2F2C3C",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        bottom: 90,   // sits just above the getMoreInsights icon at bottom: 0
                        position: "fixed",
                      }}
                    />
                  )}
                   {location.pathname !== "/landing" && (
                    <RDMenu
                      menuItems={getMoreInsightsLink()}
                      selectedOption={tabValue}
                      // setisModalVisible
                      handleMenu={(e) => setisModalVisible(true)}
                      // handleMenu={(e) => onMenuChange(e.key)}
                      mode="vertical"
                      style={{
                        width: 80,
                        background: "#2F2C3C",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-end",
                        bottom: 0,
                        position: "fixed",
                      }}
                    />
                  )}
                 
                  <GetMoreInsightsModal
                    visible={isModalVisible}
                    onClose={() => setisModalVisible(false)}
                  />
                  <UserDetailsModal
                    visible={isUserDetailsModalVisible}
                    onClose={() => setIsUserDetailsModalVisible(false)}
                  />



                </div>
              </Sider>
              <Layout style={{ background: "white" }}>
                {location.pathname !== "/landing" && (
                 <Header className="header-text1">
                  <Row style={{ height: 44 }}>
                    <Col span={18} style={{display:'inline-flex',
                      }}>
                      <div className="header-text">
                        <img
                          src={PEBGlobeIcon}
                          alt="Lilly Logo"
                          className="header-logo"
                          style={{ height: 18, marginLeft: 4 }}
                        />
                        <p className="title-text">Bank of Standards</p>
                        </div>
                        {/* Moving Text Banner */}
                        {/* <div style={{width:'70%' ,
                        cursor:'pointer'
                           }}>
                             <Tooltip title= {tabName === "Data Coverage" || tabName === ""
                              ? "After applying filters in the 'Define Target Population' widget, the Data Coverage screen displays summaries based on your data access and restrictions"
                              : "This screen displays summaries based on your data access and restrictions" 
                            }>
                        <div className="moving-text-container" 
                        >
                          
                                                
                                               
                          <div className="moving-text" 
                          >
                             {tabName === "Data Coverage" || tabName === ""
                              ? "After applying filters in the 'Define Target Population' widget, the Data Coverage screen displays summaries based on your data access and restrictions"
                              : "This screen displays summaries based on your data access and restrictions" 
                            }
                          </div>
                         
                        </div>
                         </Tooltip>
                        </div> */}
                      
                    </Col>
                    <Col span={6} style={{ textAlign: "right" }}>
                      <div className="logo-container">
                        {clientLogo && (
                          <>
                            <img
                              src={clientLogo}
                              alt="Lilly Logo"
                              style={{ ...clientLogoStyle }}
                            />
                            <Divider
                              type="vertical"
                              style={{
                                height: "24px",
                                width: 2,
                                backgroundColor: "#888B8D",
                                verticalAlign: "super",
                              }}
                            />
                          </>
                        )}
                        <img
                          src={ZSLogo}
                          alt="ZS Logo"
                          className="header-logo"
                        />
                      </div>
                    </Col>
                  </Row>
                </Header>
                )}

                <Layout style={{ background: "white" }}>
                  <Content
                    style={{
                      borderTop: "1px solid  #DEDCDE",
                    }}>
                    <div
                      style={{
                        minHeight: 360,
                      }}>
                      <AppRoutes />
                    </div>
                  </Content>
                </Layout>
              </Layout>
            </Layout>
          ) : (
            <div>
              <MaintenancePage />
            </div>
          )}

          {sessionFlag && (
            <ConcurrentSession
              onContinueSession={handleSessionContinue}
              onCancelSession={onHandleClose}
            />
          )}

          {tab === "helpCenter" ? <HelpCenter visible={true} /> : ""}
          {dataUpdatesFlag ? (
            <div>
              <DataUpdates
                visible={true}
                onClose={() => dataUpdatesDrawer(false)}
              />
            </div>
          ) : (
            ""
          )}
        </>
      )}
      </Spin>
    </div>
  );
}

export default Home;
